<template>
    <modal
        :active="active"
        @closed="$emit('closed', true)"
        title="Rediger sag"
    >
        <div class="columns is-tablet">
            <form-field
                class="column"
                label="Ansvarlig"
                :error="error.assignee"
                inner-container-class="select"
            >
                <input-select
                    placeholder="Vælg ansvarlig..."
                    v-model.number="form.assignee"
                >
                    <option
                        v-for="item in users"
                        :key="item.id"
                        :value="item.id"
                    >{{ item.name }}</option>
                </input-select>
            </form-field>
        </div>

        <template v-slot:footer class="has-space-between">
            <div class="footer-spacer">
                <div>
                    <button class="button is-danger is-flex-left" @click="reset">Nulstil</button>
                    <button class="button is-default" @click="$emit('closed', true)">Annuller</button>
                    <button class="button is-primary" @click="submit">Gem</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import { FormField, InputSelect } from '@elems/form'

export default {
    components: {
        Modal,
        FormField,
        InputSelect,
    },
    props: {
        active: Boolean,
        project: Object,
    },
    data() {
        return {
            form: {
                assignee: 0,
            },
            error: [],
        }
    },

    watch: {
        active() {
            this.reset()
        },
    },

    computed: {
        users() {
            return this.$store.getters.listUsers
        },
    },

    methods: {
        async submit() {
            await this.$store.dispatch('changeProjectAssignee', {
                'projectId': this.project.id,
                'assignee': this.form.assignee,
            })
            this.$emit('updated')
            this.$emit('closed')
        },
        reset() {
            this.form = {
                assignee: this.project.user_id,
            }
            this.error = []
        },
    }
}
</script>

<style lang="scss" scoped>
    .footer-spacer {
        width: 100%;
        display: flex;
        flex-direction:row-reverse;
        justify-content: space-between;
    }
</style>
